module.exports = __webpack_public_path__ + "static/img/0002.347ddb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/diy/0002.jpg
// module id = vsF3
// module chunks = 15